import { SeasonsApi } from '@/api';
import { NewSeason } from '@/models';
import { Season } from '@/models/geek-profile';
import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';

const seasonsApi = new SeasonsApi();

export interface SeasonsState {
  currentSeason: Season;
  seasons: Season[];
}

export const SeasonsModule: Module<SeasonsState, RootState> = {
  state: {
    currentSeason: {
      id: '',
      name: '',
      isOngoing: false,
      isGlobal: false,
      start: '',
      end: '',
    },
    seasons: [],
  },
  mutations: {
    [Mutations.seasons.setCurrentSeason](state, currentSeason: Season) {
      state.currentSeason = currentSeason;
    },
    [Mutations.seasons.setAllSeasons](state, seasons: Season[]) {
      state.seasons = seasons;
    },
  },
  actions: {
    async [Actions.seasons.fetchCurrentSeason]({ commit }): Promise<void> {
      const currentSeason = await seasonsApi.fetchCurrentSeason();
      commit(Mutations.seasons.setCurrentSeason, currentSeason);
    },
    async [Actions.seasons.fetchAllSeasons]({ commit }): Promise<void> {
      const seasons = await seasonsApi.fetchAllSeasons();
      commit(Mutations.seasons.setAllSeasons, seasons);
    },
    async [Actions.seasons.addSeason](_, season: NewSeason): Promise<void> {
      await seasonsApi.addSeason(season);
    },
    async [Actions.seasons.editSeason](_, season: NewSeason): Promise<void> {
      await seasonsApi.editSeason(season);
    },
  },
};
